import React from 'react';

export const LoaderContext = React.createContext({
  isLoading: false,
  showLoader: () => {},
  hideLoader: () => {},
});

export const LoaderContextProvider = ({ children }) => {
  let loaderCount = 0;
  const showLoader = () => {
    loaderCount = loaderCount + 1;
    const isLoading = loaderCount > 0;
    window.isLoading = isLoading;
    setLoaderState(prevState => {
      return {
        ...prevState,
        isLoading,
      };
    });
  };

  const hideLoader = () => {
    if (loaderCount > 0) {
      loaderCount = loaderCount - 1;
    } else {
      loaderCount = 0;
    }

    const isLoading = loaderCount > 0;
    window.isLoading = isLoading;

    setLoaderState(prevState => {
      return {
        ...prevState,
        isLoading,
      };
    });
  };

  const initialLoaderState = {
    isLoading: false,
    showLoader,
    hideLoader,
  };

  const [loaderState, setLoaderState] = React.useState(initialLoaderState);

  return (
    <LoaderContext.Provider value={loaderState}>
      {children}
    </LoaderContext.Provider>
  );
};

export const LoaderContextConsumer = LoaderContext.Consumer;
